module.exports = __webpack_public_path__ + "static/media/075-keyboard.36200296.svg";